<template>
  <main class="main home-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="left">
            <div class="title large text-blue">{{ $t("AngryBloxx -") }}</div>
            <div class="title big white">
              {{ $t("a Universe Built From Cubes and Imagination") }}
            </div>
            <div class="desc small white">
              {{
                $t(
                  "Log in to survive, build, and make friends inside the most welcoming Minecraft community.",
                )
              }}
            </div>
            <button class="button play w-200" @click="playNow()">
              {{ $t("Play Now") }}
            </button>
          </div>
        </div>
        <img src="./../img/hero-img.webp" class="img" />
      </div>

      <div class="section facts-section">
        <div class="wrapper">
          <div class="title big">{{ $t("Quick Facts") }}</div>
          <div class="list">
            <div class="item">
              <div class="item-wrapper">
                <img src="./../img/facts/1.svg" class="img" />
                <div class="title small blue">{{ $t("Online Capacity") }}</div>
                <div class="desc medium">
                  {{ $t("up to") }} <span class="weight-600">200</span>
                  {{ $t("concurrent players") }}
                </div>
              </div>
            </div>
            <div class="item">
              <div class="item-wrapper">
                <img src="./../img/facts/2.svg" class="img" />
                <div class="title small blue">
                  {{ $t("Supported Version") }}
                </div>
                <div class="desc medium">{{ $t("Java 1.20+") }}</div>
              </div>
            </div>
            <div class="item">
              <div class="item-wrapper">
                <img src="./../img/facts/3.svg" class="img" />
                <div class="title small blue">{{ $t("Security") }}</div>
                <div class="desc medium">
                  {{ $t("robust, battle-tested anti-cheat system") }}
                </div>
              </div>
            </div>
            <div class="item">
              <div class="item-wrapper">
                <img src="./../img/facts/4.svg" class="img" />
                <div class="title small blue">{{ $t("Economy") }}</div>
                <div class="desc medium">
                  {{ $t("player-driven market with transparent auctions") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section about-section">
        <div class="wrapper">
          <img src="./../img/about.webp" class="img" />
          <div class="right">
            <div class="text">
              <div class="title small">
                <span class="weight-600">{{ $t("About the Server") }}</span>
              </div>
              <div class="title big weight-400">
                <span class="text-blue">{{ $t("AngryBloxx") }}</span>
                {{ $t("was created by fans, for fans.") }}
              </div>
              <div class="desc medium">
                {{
                  $t(
                    "No clutter of extra game modes—just enhanced Survival powered by custom plugins that keep every session fresh and fair.",
                  )
                }}
              </div>
              <button class="button play w-200" @click="playNow()">
                {{ $t("Play Now") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="section features-section">
        <div class="wrapper">
          <div class="left">
            <div class="text">
              <div class="title big">
                <span class="weight-600">{{ $t("Key Features") }}</span>
              </div>
              <div class="list">
                <div class="item">
                  <img src="./../img/features/01.svg" class="img" />
                  <div class="text">
                    <div class="title small blue">
                      {{ $t("Custom World Generation") }}
                    </div>
                    <div class="desc medium">
                      {{
                        $t(
                          "New biomes, hidden ruins, and rare mobs mean the ground beneath you is never routine.",
                        )
                      }}
                    </div>
                  </div>
                </div>
                <div class="item">
                  <img src="./../img/features/02.svg" class="img" />
                  <div class="text">
                    <div class="title small blue">
                      {{ $t("Living Economy") }}
                    </div>
                    <div class="desc medium">
                      {{
                        $t(
                          "Auctions and player shops keep prices fair and encourage trade over griefing.",
                        )
                      }}
                    </div>
                  </div>
                </div>
                <div class="item">
                  <img src="./../img/features/03.svg" class="img" />
                  <div class="text">
                    <div class="title small blue">{{ $t("Guild System") }}</div>
                    <div class="desc medium">
                      {{
                        $t(
                          "Team up for mega-projects, build fortified bases, and defend against mob sieges.",
                        )
                      }}
                    </div>
                  </div>
                </div>
                <div class="item">
                  <img src="./../img/features/04.svg" class="img" />
                  <div class="text">
                    <div class="title small blue">
                      {{ $t("Weekly Challenges") }}
                    </div>
                    <div class="desc medium">
                      {{
                        $t(
                          "In-game tasks with rewards ranging from unique items to rare achievements.",
                        )
                      }}
                    </div>
                  </div>
                </div>
                <div class="item">
                  <img src="./../img/features/05.svg" class="img" />
                  <div class="text">
                    <div class="title small blue">
                      {{ $t("24/7 Moderation") }}
                    </div>
                    <div class="desc medium">
                      {{
                        $t(
                          "Staff are always on hand to help and keep the gameplay clean.",
                        )
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img src="./../img/features.webp" class="img img-main" />
        </div>
      </div>

      <div class="section join-section">
        <div class="wrapper">
          <div class="title big weight-600">{{ $t("How to Join") }}</div>
          <div class="main-desc desc medium">{{ $t("3 Easy Steps") }}</div>
          <div class="list">
            <div class="item">
              <div class="desc step blue weight-600">{{ $t("01 step") }}</div>
              <div class="title small blue">{{ $t("Copy the IP:") }}</div>
              <button class="copy" @click="copy">
                <div class="desc medium weight-600">
                  {{
                    ipCopied ? $t("copied") : $parent.ip + ":" + $parent.port
                  }}
                </div>
                <img src="./../img/copy.svg" class="img" />
              </button>
            </div>
            <div class="item">
              <div class="desc step blue weight-600">{{ $t("02 step") }}</div>
              <div class="title small blue">{{ $t("Launch Minecraft") }}</div>
              <div class="desc medium">
                {{ $t("Java Edition 1.20 or newer") }}
              </div>
            </div>
            <div class="item">
              <div class="desc step blue weight-600">{{ $t("03 step") }}</div>
              <div class="title small blue">{{ $t("Add the server") }}</div>
              <div class="add">
                <div class="desc medium">{{ $t("in “Multiplayer”") }}</div>
                <div class="desc small weight-600">→ {{ $t("Join") }}</div>
              </div>
            </div>
          </div>
          <div class="tip">
            <div class="icon">
              <img src="./../img/bulb.svg" class="img" />
            </div>
            <div class="desc medium">
              <b>{{ $t("Tip:") }}</b>
              {{
                $t(
                  "Enable the server resource pack at login to see the world in full color.",
                )
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="section shop-section">
        <div class="wrapper">
          <div class="left">
            <div class="title-container">
              <div class="title big weight-600">
                {{ $t("Buy Packs —") }}<br />{{ $t("Save on Every Bundle") }}
              </div>
            </div>

            <div class="desc medium">
              {{
                $t(
                  "In the our store, you can buy not only individual items but also ready-made bundles. These themed resource packs cover all your needs at once—and cost noticeably less than purchasing the same items separately.",
                )
              }}
            </div>

            <div class="list">
              <div class="item">
                <div class="item-left">
                  <div class="icon">
                    <img src="./../img/star.svg" class="img" />
                  </div>
                  <div class="title small blue">
                    {{ $t("Instant delivery") }}
                  </div>
                </div>
                <div class="item-right">
                  <div class="desc small">
                    {{
                      $t(
                        "the bundle is added to your inventory (or the server) right after payment.",
                      )
                    }}
                  </div>
                </div>
              </div>

              <div class="item">
                <div class="item-left">
                  <div class="icon">
                    <img src="./../img/star.svg" class="img" />
                  </div>
                  <div class="title small blue">
                    {{ $t("Convenient and themed") }}
                  </div>
                </div>
                <div class="item-right">
                  <div class="desc small">
                    {{
                      $t(
                        "we offer packs for farming, building, PvP, and more—pick exactly what you need.",
                      )
                    }}
                  </div>
                </div>
              </div>

              <div class="item">
                <div class="item-left">
                  <div class="icon">
                    <img src="./../img/star.svg" class="img" />
                  </div>
                  <div class="title small blue">
                    {{ $t("More time playing, less time shopping") }}
                  </div>
                </div>
                <div class="item-right">
                  <div class="desc small">
                    {{
                      $t(
                        "instead of buying items one by one, get everything in a single click.",
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div class="desc desc-last medium">
              {{
                $t(
                  "100 % of proceeds fund server hosting and future development.",
                )
              }}
            </div>
          </div>

          <div class="img-container">
            <img src="./../img/shop.webp" class="img img-main" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Home",
  props: [],
  components: {},
  data: function () {
    return {
      email: "",
      name: "",
      message: "",
      nickname: "",
      activePanels: [],
      ipCopied: false,
    };
  },
  mounted() {},
  methods: {
    copy() {
      let self = this;
      var textarea = document.createElement("textarea");
      textarea.value = self.$parent.ip + ":" + self.$parent.port;
      document.body.appendChild(textarea);

      textarea.select();
      document.execCommand("copy");

      document.body.removeChild(textarea);
      self.ipCopied = true;

      setTimeout(() => {
        self.ipCopied = false;
      }, 2000);
    },
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1);
      } else {
        this.activePanels.push(index);
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index);
    },
    submit() {
      let data = {
        name: this.name,
        email: this.email,
        message: this.message,
      };
      this.$emit("sendContactForm", data);
    },
    playNow() {
      if (this.$parent.isAuth) {
        this.$router.push({ path: "/categories" });
      } else {
        this.$parent.openSignIn();
      }
    },
  },
};
</script>
